import type { SlackWorkspaceInstallsListApiData, SlackWorkspaceInstallsListApiResponses } from '@navio/nsdk';

import { apiUrl, dataEndpoint } from '../defineResource';

export const getSlackUrls = {
  getPaginatedSlackWorkspaceInstalls: dataEndpoint<
    SlackWorkspaceInstallsListApiData,
    SlackWorkspaceInstallsListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('communication/slack/workspace-installs/', queryParams)
  })
};
